import { Component, Input } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-ai-review-filter',
  template: `
    <div style="display: flex; align-items: center; gap: 5px;">
      <input type="checkbox"
             kendoCheckBox
             [checked]="selectedValue"
             (change)="onChange($event)"/>
      <label class="k-label">AI Review?</label>
    </div>
  `,
  standalone: false
})
export class AiReviewFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): boolean {
    const filter = this.filterByField('is_claude');
    return filter ? filter.value : false;
  }

  @Input() public override filter: any;

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(event: any): void {
    const checked = event.target.checked;
    this.applyFilter(
      this.updateFilter({
        field: 'is_claude',
        operator: 'eq',
        value: checked
      })
    );
  }
}
